import * as types from "../actionTypes";
import * as eventTypes from "../eventTypes";
import initialState from "reducers/initialState";

export const facilityKpiIndicatorsReducer = (state = initialState.facilities.facilityKpiIndicators, action) => {
  switch (action.type) {
    case types.LOAD_FACILITY_KPI_INDICATORS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };

      return result;
    }

    case types.LOAD_FACILITY_KPI_INDICATORS_SUCCEEDED: {
      const { key, payload } = action;
      let result = { ...state };
      result[key] = { ...state[key], kpiIndicators: payload, loading: false, loaded: true };

      return result;
    }

    case types.LOAD_FACILITY_KPI_INDICATORS_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: false };

      return result;
    }

    case eventTypes.FACILITY_ITEM_TYPE_KPIS_SAVED: {
      const { documentId, kpiIndicators } = action.event.eventBody;
      let result = { ...state };

      for (let [, value] of Object.entries(kpiIndicators)) {
        for (let [resultKey, resultValue] of Object.entries(result[documentId].kpiIndicators)) {
          if (value.indicatorId === resultValue.indicatorId && value.itemTypeId === resultValue.itemTypeId) {
            result[documentId].kpiIndicators[resultKey] = { ...state[documentId].kpiIndicators[resultKey], ...value };
          }
        }
      }
      return result;
    }

    default:
      return state;
  }
};
